import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerValidaPecModalComponent } from './worker-valida-pec-modal';

export const WorkerValidaPecModalModule: string = ng
    .module('worker-valida-pec-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerValidaPecModalComponent', WorkerValidaPecModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-valida-pec-modal/worker-valida-pec-modal.module.ts